import React from "react";
import { getStatusLabel, isActiveStatus } from "../../utils/masterHelpers";

export default function StatusBadge({ value }) {
  const label = getStatusLabel(value);

  let modifier = "masters-status-badge--neutral";

  if (label !== "-") {
    modifier = isActiveStatus(value)
      ? "masters-status-badge--active"
      : "masters-status-badge--inactive";
  }

  return (
    <span className={`masters-status-badge ${modifier}`.trim()}>{label}</span>
  );
}
